import React from 'react';

const Maintainance = () => {
  return (
    <>
      <style>
        {`
          .maintenance-container {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            background-color: #f3f4f6;
            text-align: center;
            padding: 0 1rem;
          }

          .maintenance-content h1 {
            font-size: 2.5rem;
            font-weight: bold;
            color: #1f2937;
            margin-bottom: 1rem;
          }

          .maintenance-content p {
            font-size: 1.125rem;
            color: #4b5563;
          }
        `}
      </style>
      <div className="maintenance-container">
        <div className="maintenance-content">
          <h1>Website Under Maintenance</h1>
          <p>We’re currently performing scheduled updates. Please check back soon.</p>
        </div>
      </div>
    </>
  );
};

export default Maintainance;

